import { RME_IN_REVIEW_ID, RME_IN_REVIEW_NAME } from '@m/constants/RmeStatus';
import { AssociatedVehicleUser, RmeStatus } from '@m/types/api';

export const vehicleUserHasSharedDriver = (
  requestingUserVehicle: AssociatedVehicleUser | undefined,
) => {
  return requestingUserVehicle?.role?.name === 'Shared';
};

export const isRmeStatusInReview = (rmeStatus?: RmeStatus | null): boolean => {
  return (
    rmeStatus?.status?.id === RME_IN_REVIEW_ID || rmeStatus?.status?.name === RME_IN_REVIEW_NAME
  );
};
